import { useTranslation } from 'react-i18next'
import mapValues from 'lodash-es/mapValues'

import { BirdviewActivitiesWidget } from '../../../BirdviewActivitiesWidget'
import { BirdviewAttentionWidget } from '../../../BirdviewAttentionWidget'
import { BirdviewCommunicationWidget } from '../../../BirdviewCommunicationWidget'
import { BirdviewDocFlowsWidget } from '../../../BirdviewDocFlowsWidget'
import { BirdviewGretaWidget } from '../../../BirdviewGretaWidget'
import { BirdviewPropertiesWidget } from '../../../BirdviewPropertiesWidget'
import { BirdviewServiceRequestsWidget } from '../../../BirdviewServiceRequestsWidget'
import { BIRDVIEW_SECTION_TARGET } from '../../../DashboardBirdview.constants.targets'
import {
  BIRDVIEW_OPERATIONAL_WIDGET_TITLE_KEY,
  BirdviewOperationalWidget,
} from '../../BirdviewOperational.constants'
import { getBirdviewOperationalSections } from '../../BirdviewOperational.utils'

export function useBirdviewOperationalWidgets({
  activityDoneById,
  pendingIds,
  requestActions,
  sections,
  onActivityToggle,
  onLoadAttentionGroup,
  onNavigate,
}) {
  const { t } = useTranslation()

  const {
    activities,
    attention,
    communication,
    docFlows,
    greta,
    properties,
    serviceRequests,
    tiles,
  } = getBirdviewOperationalSections(sections)

  const widgetTitles = mapValues(BIRDVIEW_OPERATIONAL_WIDGET_TITLE_KEY, key =>
    t(key)
  )

  const widgets = {
    [BirdviewOperationalWidget.Activities]: dragHandleProps => (
      <BirdviewActivitiesWidget
        activityDoneById={activityDoneById}
        dragHandleProps={dragHandleProps}
        pendingIds={pendingIds}
        section={activities}
        title={widgetTitles[BirdviewOperationalWidget.Activities]}
        onActivityToggle={onActivityToggle}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewOperationalWidget.Attention]: dragHandleProps => (
      <BirdviewAttentionWidget
        dragHandleProps={dragHandleProps}
        requestActions={requestActions}
        section={attention}
        title={widgetTitles[BirdviewOperationalWidget.Attention]}
        onLoadAttentionGroup={onLoadAttentionGroup}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewOperationalWidget.Communication]: dragHandleProps => (
      <BirdviewCommunicationWidget
        dragHandleProps={dragHandleProps}
        section={communication}
        title={widgetTitles[BirdviewOperationalWidget.Communication]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewOperationalWidget.DocFlows]: dragHandleProps => (
      <BirdviewDocFlowsWidget
        dragHandleProps={dragHandleProps}
        section={docFlows}
        title={widgetTitles[BirdviewOperationalWidget.DocFlows]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewOperationalWidget.Greta]: dragHandleProps => (
      <BirdviewGretaWidget
        dragHandleProps={dragHandleProps}
        section={greta}
        title={widgetTitles[BirdviewOperationalWidget.Greta]}
      />
    ),
    [BirdviewOperationalWidget.Properties]: dragHandleProps => (
      <BirdviewPropertiesWidget
        dragHandleProps={dragHandleProps}
        section={properties}
        showAllTarget={BIRDVIEW_SECTION_TARGET.properties}
        title={widgetTitles[BirdviewOperationalWidget.Properties]}
        onNavigate={onNavigate}
      />
    ),
    [BirdviewOperationalWidget.ServiceRequests]: dragHandleProps => (
      <BirdviewServiceRequestsWidget
        dragHandleProps={dragHandleProps}
        requestActions={requestActions}
        section={serviceRequests}
        showAllTarget={BIRDVIEW_SECTION_TARGET.requests}
        title={widgetTitles[BirdviewOperationalWidget.ServiceRequests]}
        onNavigate={onNavigate}
      />
    ),
  }

  return { tiles, widgets, widgetTitles }
}
